import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_ALL_CUSTOMER_LINKS_REQUEST = 'GET_ALL_CUSTOMER_LINKS_REQUEST';
export const GET_ALL_CUSTOMER_LINKS_SUCCESS = 'GET_ALL_CUSTOMER_LINKS_SUCCESS';
export const GET_ALL_CUSTOMER_LINKS_FAILURE = 'GET_ALL_CUSTOMER_LINKS_FAILURE';

function getAllCustomerLinksRequest() {
  return {
    type: GET_ALL_CUSTOMER_LINKS_REQUEST
  };
}

function getAllCustomerLinksRecieved(customerLinks) {
  return {
    type: GET_ALL_CUSTOMER_LINKS_SUCCESS,
    customerLinks
  };
}

function getAllCustomerLinksFailed() {
  return {
    type: GET_ALL_CUSTOMER_LINKS_FAILURE,
  };
}

export function getAllCustomerLinks(customerId) {
  return (dispatch) => {
    dispatch(getAllCustomerLinksRequest());
    const promise = () => ApiService
      .getAllCustomerLinks(customerId)
      .then(response => dispatch(getAllCustomerLinksRecieved(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, getAllCustomerLinksFailed, true));
        }
      });
    return promise();
  };
}
